import { useTranslate } from '@/components/Helpers/Translate'
import type { CosmicVariationType } from '@/lib/cms/cosmic/types/CosmicProductType'
import { getTerms } from '@/lib/hooks/services/useGetTerms'
import useGlobalStore from '@/store/useGlobalStore'

type Props = {
  selectedVariation: CosmicVariationType | null
}

export const ProductDetailsSubtitle = ({ selectedVariation }: Props) => {
  const {
    user: { customerType },
  } = useGlobalStore()
  const { translate } = useTranslate()

  const isAssociate = customerType === 'Associate'

  const selectedPv = getTerms({
    forCustomerType: customerType,
    pricingData: selectedVariation?.pricing || null,
  })?.pvEach

  const handleDisplayPartsData = () => {
    const partsData = selectedVariation?.partsLabel

    if (partsData) {
      return (
        <p>
          {partsData}
          <span className="mx-3">|</span>
        </p>
      )
    }

    return null
  }

  return (
    <div className="flex max-w-full">
      {handleDisplayPartsData()}

      {isAssociate ? (
        <>
          <p>
            {translate('pv')}: {selectedPv}
          </p>
          <span className="mx-3">|</span>
        </>
      ) : null}
      <p>
        {translate('sku')}: {selectedVariation?.sku}
      </p>
    </div>
  )
}
